import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../i18n/context';
import './ToolboxReturnPanel.css';

function ToolboxReturnPanel({
  className = '',
  description,
  links = [],
}) {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <section className={`toolbox-return-panel ${className}`.trim()}>
      <div>
        <span>{t('toolbox.moreTools')}</span>
        <h2>{t('toolbox.continueExplore')}</h2>
        <p>{description || t('toolbox.defaultDesc')}</p>
      </div>
      <div className="toolbox-return-actions">
        <button onClick={() => navigate('/tools')}>{t('toolbox.openToolbox')}</button>
        {links.map((link) => (
          <button key={link.href} onClick={() => navigate(link.href)}>{link.label}</button>
        ))}
      </div>
    </section>
  );
}

export default ToolboxReturnPanel;
